/**
 * file : Paging.jsx
 * 설명 : 페이징 처리
 */

import { Link } from 'react-router-dom';

export default function Paging() {
  return (
    <div className='paging-area'>
        <ul>
            <li>
                <Link to="" className="prev-first" alt="첫 페이지로 이동"><span>맨앞으로</span></Link>
            </li>
            <li>
                <Link to="" className='CurrentPage'>1</Link>
            </li>  
            <li>
                <Link to="" className="next-last" alt="마지막 페이지로 이동"><span>맨앞맨뒤로으로</span></Link>
            </li>		  
        </ul>
    </div>
  )
}